/**
 * 忘记密码页面
 */
import './index.less';

import { FC, lazy, Suspense, useEffect, useState } from 'react';

import BySecurity, { ISecurityData } from '@/components/NewSecurity';
import { useFingerPrint } from '@/hooks/useFingerPrint';
import { useUserStore } from '@/store/useUser';
import { complianceHide } from '@/utils/complianceHelpers';

import EmailOrMobile from './comps/EmailOrMobile';
// import NewPassword from './comps/NewPassword';
import { IEmailOrMobile } from './types';

const NewPassword = lazy(() => import('./comps/NewPassword'));

const Retrieve: FC = () => {
  const [step, setStep] = useState<number>(0);
  const [info, setInfo] = useState<IEmailOrMobile>({ tapKey: '1' });
  const [risk_token, setRiskToken] = useState<any>();
  const [showRiskToken, setShowRiskToken] = useState<any>();
  const { fingerReport } = useFingerPrint();

  const { complianceConfig } = useUserStore();

  useEffect(() => {
    fingerReport('wf04', '2');
  }, []);

  const _setRiskToken = (value: string) => {
    setRiskToken(value);
    if (value) {
      nextStep();
    }
  };

  const showSecurity = (info: IEmailOrMobile, risk_token: string) => {
    setInfo(info);
    setShowRiskToken(risk_token);
  };

  const nextStep = (info?: IEmailOrMobile) => {
    info && setInfo(info);
    setStep(1);
  };

  const securityInfo: ISecurityData = {
    username: info.tapKey === '1' ? info.email : info.mobile,
    country_code: info.country_code,
  };

  useEffect(() => {
    if (complianceHide(complianceConfig?.RetrievePageSecurityFindEntry)) {
      const hideSecurityFindEntry = document.createElement('style');
      hideSecurityFindEntry.setAttribute(
        'id',
        'SecurityVerificationNotAvailableStyle',
      );
      hideSecurityFindEntry.innerHTML = `div[data-security-comp="SecurityVerificationNotAvailable"] {
        display: none;
      }`;
      if (showRiskToken) {
        document.head.appendChild(hideSecurityFindEntry);
      } else {
        if (document.getElementById('SecurityVerificationNotAvailableStyle')) {
          document.head.removeChild(hideSecurityFindEntry);
        }
      }

      return () => {
        if (document.getElementById('SecurityVerificationNotAvailableStyle')) {
          document.head.removeChild(hideSecurityFindEntry);
        }
      };
    }
  }, [showRiskToken]);

  return (
    <>
      {showRiskToken && (
        <BySecurity
          loginData={securityInfo}
          risk_token={showRiskToken}
          faceFailHandler={() => {
            setShowRiskToken(undefined);
          }}
          clearTokenHandler={() => {
            setShowRiskToken(undefined);
          }}
          callBack={(res: any) => {
            _setRiskToken(res?.result.risk_token);
          }}
        />
      )}
      {step === 0 && (
        <EmailOrMobile
          nextStep={nextStep}
          risk_token={risk_token}
          showSecurity={showSecurity}
        />
      )}
      <Suspense fallback={''}>
        {step === 1 && <NewPassword info={info} risk_token={risk_token} />}
      </Suspense>
    </>
  );
};

export default Retrieve;
